import { Box, Typography, styled } from '@mui/material'
import * as R from 'ramda'
import './changelog.css'

const TitleContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '1px 8px',
  width: 'fit-content',
  height: '26px',
  borderRadius: '4px',
})

const SpanContainer = styled('div')`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledSpan = styled('span')`
  width: 4px;
  height: 4px;
  background: #e6e6e6;
  margin-top: 2px;
  border-radius: 50%;
`

interface Props {
  title: string
  bgcolor: string
  items: string[]
  icon: JSX.Element
  mt: number
  mb: number
}

export const ContentContainer = ({
  items,
  title,
  bgcolor,
  icon,
  mt,
  mb,
}: Props) => {
  return (
    <Box>
      <TitleContainer bgcolor={bgcolor} mt={mt} mb={mb}>
        {icon}

        <Typography variant="subtitle1" mr={1}>
          {title}
        </Typography>
      </TitleContainer>

      {items.map((item, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index} display="flex" mb={1}>
            <SpanContainer>
              <StyledSpan />
            </SpanContainer>

            {item && R.startsWith('<', item) ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              />
            ) : (
              <Typography variant="body2">{item}</Typography>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
